"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorsMap = void 0;
var BadgeProps_1 = require("./BadgeProps");
var styles = require("./Badge.css");
exports.colorsMap = new Map([
    [BadgeProps_1.BadgeColors.GREEN, styles.green],
    [BadgeProps_1.BadgeColors.BLACK, styles.black],
    [BadgeProps_1.BadgeColors.RED, styles.red],
    [BadgeProps_1.BadgeColors.ORANGE, styles.orange],
]);
// export const sizesMap = new Map<ButtonSize, string>([
//   [ButtonSize.LARGE, styles.large],
// ]);
//# sourceMappingURL=BadgeStylesMap.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Badge/BadgeStylesMap.js
// module id = 1037
// module chunks = 8